module.exports = __webpack_public_path__ + "static/media/contact.7b42a564.png";